<template>
  <div>
    <AlterFormLayout
      modalId="inss-alter-modal"
      formTitle="Alterar informações de INSS"
      cancelButtonText="Cancelar"
      submitButtonText="Enviar solicitação de Ateração"
      :onSubmitEvent="onSubmit"
      :disableEvent="this.$store.getters.isAdmin"
      :onCancelEvent="onCancel"
      :onCancelCloseEvent="onCancelCloseEvent"
    >
      <template #content>
        <InssForm
          :loadedFormData="$props.loadedFormData"
          :isValidatedPIS="isValidatedPIS"
        />
      </template>
    </AlterFormLayout>
    <success-modal
      ref="success-modal"
      description="Sua solicitação de alteração
    das informações de INSS foi enviada."
      buttonText="Ok, entendi!"
      :protocol="this.protocol"
      subdescription="Os dados alterados serão
    analisados e atualizados após a validação."
    />
  </div>
</template>

<script>
import InssForm from "./InssForm.vue";
import AlterFormLayout from "../../../../../layouts/AlterFormLayout.vue";
import { updateInssInformation } from "../../../../../services/inss/inss-services";
import SuccessModal from "../../../../../components/base-modals/SuccessModal.vue";

export default {
  props: ["loadedFormData"],
  components: {
    AlterFormLayout,
    InssForm,
    SuccessModal,
  },
  data() {
    return {
      protocol: "",
      isValidatedPIS: true,
    };
  },
  methods: {
    onCancelCloseEvent() {
      return this.isValidatedPIS;
    },
    onCancel() {
      this.isValidatedPIS = true;
    },
    async onSubmit(formData) {
      try {
        this.protocol = await updateInssInformation(formData, formData.files);
        const modal = this.$refs["success-modal"].$children[0];
        modal.show();
        await this.$store.dispatch(
          "requestUserInformation",
          this.$store.getters.getUserName
        );

        this.$emit("userInfoUpdated");
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error_code === "INVALID_PIS_ERP"
        ) {
          this.isValidatedPIS = false;
        }
      }
    },
  },
};
</script>
